import type { InsightCard } from "../aidwops.types";
import tooltipsData from "./AidwopsTooltips.json";

function stripeClass(i: number) {
  return i === 0 ? "p1" : i === 1 ? "p1" : i === 2 ? "p2" : "p3";
}

const actionTooltips: Record<string, string> = {
  ...(tooltipsData.insights || {}),
  ...(tooltipsData.top_actions || {}),
};

export function TopActions({
  actions,
  loading,
  onActionClick,
}: {
  actions: InsightCard[];
  loading?: boolean;
  onActionClick?: (action: InsightCard) => void;
}) {
  const cardTooltip = tooltipsData.top_actions?.items_waiting_decision;

  return (
    <div className="card" title={cardTooltip}>
      <div className="card-header">
        <span className="ic">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M9 18v-1a5 5 0 0 1 10 0v1M14 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          </svg>
        </span>
        <div>
          <div className="card-title">Top actions</div>
          <div className="card-title-sub">Ranked by urgency and blast radius</div>
        </div>
      </div>
      <div className="action-list">
        {loading &&
          actions.length === 0 &&
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="skeleton-row">
              <div className="skeleton" style={{ width: 22, height: 22, borderRadius: 6 }} />
              <div className="skeleton" />
            </div>
          ))}
        {!loading && actions.length === 0 && <p className="section-sub">Nothing to review right now.</p>}
        {actions.map((action, i) => {
          const cls = stripeClass(i);
          const rowTooltip =
            actionTooltips[action.id] ||
            (action.queueId ? actionTooltips[action.queueId] : undefined);
          return (
            <div key={action.id} className="action-row" title={rowTooltip}>
              <span className={`action-stripe ${cls}`} />
              <span className={`action-rank${cls === "p1" ? " p1" : ""}`}>{i + 1}</span>
              <div className="action-body">
                <div className="action-name">
                  {action.title} — {action.value}
                </div>
                {action.detail && <div className="action-meta">{action.detail}</div>}
              </div>
              <button
                className="action-cta"
                onClick={() => action.queueId && onActionClick?.(action)}
                aria-label={
                  action.queueId
                    ? `Open expert queue item: ${action.title}`
                    : `Review ${action.title}`
                }
              >
                {action.queueId ? "Open queue →" : "Review →"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
